import { distance } from '@ro-utils/common/helpers';

import {
  LAYER_RADAR,
  LAYER_ESTOFEX,
  LAYER_SKYPREDICT,
  LAYER_SNOW_COVER,
  LAYER_SYNOP,
  LayerName
} from '@ro-utils/constant';

import {
  Props as RoTooltipComponentProps,
  AppMap,
  RoLayer,
  RoFeature,
  CurrentLocation,
  PreparedData,
  TooltipProperties,
  PolygonMeta,
  NearestStation
} from '@ro-atoms/RoTooltip/RoTooltip.types';

const getNearestPoint = (arr: PreparedData[], currentLocation: CurrentLocation) => {
  const defaultNearest: NearestStation = {
    dist: undefined,
    synop: undefined
  };
  let nearest: NearestStation = {
    ...defaultNearest
  };
  arr &&
    arr.map((item: PreparedData) => {
      const currentLocationData = currentLocation && currentLocation.original;
      const synopDist = distance(currentLocationData[1], currentLocationData[0], item.lat, item.lon);
      if (nearest) {
        if (!nearest.dist || nearest.dist > synopDist) {
          nearest =
            synopDist < 20
              ? {
                  dist: synopDist,
                  synop: item
                }
              : {
                  ...defaultNearest
                };
        }
      }
      return false;
    });

  return nearest;
};

const checkType = (layer: RoLayer | RoFeature, type: LayerName) => {
  return layer && layer.meta && layer.meta.UIType === type;
};

export const setTooltipProperties = (props: RoTooltipComponentProps, map: AppMap) => {
  const { synopData, currentLocation, snowCoverData } = props;

  const pixel = currentLocation.transformed && map.getPixelFromCoordinate(currentLocation.transformed);

  let polygons: PolygonMeta = {};
  let nearestSynop: NearestStation = undefined;
  let nearestSnowSynop: NearestStation = undefined;
  let radarColor = '';

  const enabledLayers: { [key: string]: boolean } = {
    [LAYER_RADAR]: true,
    [LAYER_SYNOP]: true,
    [LAYER_SNOW_COVER]: true
  };

  if (pixel) {
    map.forEachLayerAtPixel(
      pixel,
      (layer: RoLayer, color) => {
        layer.getClassName() === LAYER_RADAR && (radarColor = 'rgba(' + color + ')');
      },
      {
        hitTolerance: 0,
        layerFilter: (layer: RoLayer) => {
          const enable = layer.meta && layer.meta.UIType && Boolean(enabledLayers[layer.meta.UIType]);
          if (enable) {
            checkType(layer, LAYER_SYNOP) && (nearestSynop = getNearestPoint(synopData, currentLocation));
            checkType(layer, LAYER_SNOW_COVER) && (nearestSnowSynop = getNearestPoint(snowCoverData, currentLocation));
          }
          return layer.getClassName() === LAYER_RADAR;
        }
      }
    );

    const features = map.getFeaturesAtPixel(pixel);
    features &&
      features.forEach((feature: RoFeature) => {
        if (checkType(feature, LAYER_SKYPREDICT)) {
          const meta = feature.meta;
          const spWarning = meta && polygons[`${meta.title}_sp`];
          if (meta.priority > spWarning?.priority || !spWarning) {
            polygons[`${meta.title}_sp`] = meta;
          }
        }
        if (checkType(feature, LAYER_ESTOFEX)) {
          const meta = feature.meta;
          const estofexWarning = meta && polygons[`${meta.title}_estofex`];
          if (meta.priority > (estofexWarning && estofexWarning.priority) || !estofexWarning) {
            polygons[`${meta.title}_estofex`] = meta;
          }
        }
      });
  }

  const tooltipProperties: TooltipProperties = pixel && {
    polygons,
    color: radarColor,
    nearestSynop,
    nearestSnowSynop
  };
  return tooltipProperties;
};
